import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { MessageBodyMatchesState } from "@redotech/redo-return-ui/flows/rules/conditions/message-body-matches";
import { RedoTagInputField } from "@redotech/redo-web/arbiter-components/input/redo-tag-input-field";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { Checkbox } from "@redotech/redo-web/checkbox";
import { Flex } from "@redotech/redo-web/flex";
import { LabeledInput } from "@redotech/redo-web/labeled-input";
import { memo, useState } from "react";

export const MessageBodyMatchesDetails = memo(
  function MessageBodyMatchesDetails({
    state,
    setState,
    disabled,
  }: ConditionTypeDetailsProps<MessageBodyMatchesState>) {
    const [inputValue, setInputValue] = useState("");

    const matchModeOptions = [
      {
        id: "INCLUDES",
        type: "text" as const,
        text: "contains",
        value: "INCLUDES",
      },
      {
        id: "IS_EXACTLY",
        type: "text" as const,
        text: "entire message is exactly",
        value: "IS_EXACTLY",
      },
    ];

    const selectedMatchMode = matchModeOptions.find(
      (option) => option.id === state.matchMode,
    );

    return (
      <>
        <RedoSingleSelectDropdownInput
          disabled={disabled}
          label="Match mode"
          options={matchModeOptions}
          optionSelected={({ item }) => {
            setState({
              ...state,
              matchMode: item.id as typeof state.matchMode,
            });
          }}
          selectedItem={selectedMatchMode}
        />
        <RedoTagInputField
          delimiters={["newline"]}
          inputValue={inputValue}
          label="Message body text to match"
          placeholder="Enter message body text to match"
          setInputValue={setInputValue}
          setTags={(queryStrings) => {
            const uniqueStrings = Array.from(new Set(queryStrings));
            setState({ ...state, queryStrings: uniqueStrings });
          }}
          state={disabled ? "disabled" : "default"}
          tags={(state.queryStrings || []).map((text) => ({ text }))}
        />

        <Flex>
          <LabeledInput label="Case sensitive">
            <Checkbox
              onChange={(v) => setState({ ...state, caseSensitive: v })}
              value={state.caseSensitive}
            />
          </LabeledInput>{" "}
        </Flex>
      </>
    );
  },
);
